module.exports = __webpack_public_path__ + "media/images/japan/useful_2-bd861fd20b76fc9b975232fd3d8e4aef.jpg";